const items = [
    {
        id:1,
        name:"Big Mac",
        price:2,
        link:"https://neal.fun/spend/images/big-mac.jpg",
        count:0
    },
    {
        id:2,
        name:"Flip Flops",
        price:3,
        link:"https://neal.fun/spend/images/flip-flops.jpg",
        count:0
    },
    {
        id:3,
        name:"Coca-Cola Pack",
        price:5,
        link:"https://neal.fun/spend/images/coca-cola-pack.jpg",
        count:0
    },
    {
        id:4,
        name:"Movie Ticket",
        price:12,
        link:"https://neal.fun/spend/images/movie-ticket.jpg",
        count:0
    },
    {
        id:5,
        name:"Book",
        price:15,
        link:"https://neal.fun/spend/images/book.jpg",
        count:0
    },
    {
        id:6,
        name:"Lobster Dinner",
        price:45,
        link:"https://neal.fun/spend/images/lobster-dinner.jpg",
        count:0
    },
    {
        id:7,
        name:"Video Game",
        price:60,
        link:"https://neal.fun/spend/images/video-game.jpg",
        count:0
    },
    {
        id:8,
        name:"Amazon Echo",
        price:99,
        link:"https://neal.fun/spend/images/amazon-echo.jpg",
        count:0
    },
    {
        id:9,
        name:"Year of Netflix",
        price:100,
        link:"https://neal.fun/spend/images/year-of-netflix.jpg",
        count:0
    },
    {
        id:10,
        name:"Air Jordans",
        price:125,
        link:"https://neal.fun/spend/images/air-jordans.jpg",
        count:0
    },
    {
        id:11,
        name:"Airpods",
        price:199,
        link:"https://neal.fun/spend/images/airpods.jpg",
        count:0
    },
    {
        id:12,
        name:"Gaming Console",
        price:299,
        link:"https://neal.fun/spend/images/gaming-console.jpg",
        count:0
    },
    {
        id:13,
        name:"Drone",
        price:350,
        link:"https://neal.fun/spend/images/drone.jpg",
        count:0
    },
    {
        id:14,
        name:"Smartphone",
        price:699,
        link:"https://neal.fun/spend/images/smartphone.jpg",
        count:0
    },
    {
        id:15,
        name:"Bike",
        price:800,
        link:"https://neal.fun/spend/images/bike.jpg",
        count:0
    },
    {
        id:16,
        name:"Kitten",
        price:1500,
        link:"https://neal.fun/spend/images/kitten.jpg",
        count:0
    },
    {
        id:17,
        name:"Puppy",
        price:1500,
        link:"https://neal.fun/spend/images/puppy.jpg",
        count:0
    },
    {
        id:18,
        name:"Auto Rickshaw",
        price:2300,
        link:"https://neal.fun/spend/images/auto-rickshaw.jpg",
        count:0
    },
    {
        id:19,
        name:"Horse",
        price:2500,
        link:"https://neal.fun/spend/images/horse.jpg",
        count:0
    },
    {
        id:20,
        name:"Acre of Farmland",
        price:3000,
        link:"https://neal.fun/spend/images/acre-of-farmland.jpg",
        count:0
    },
    {
        id:21,
        name:"Designer Handbag",
        price:5500,
        link:"https://neal.fun/spend/images/designer-handbag.jpg",
        count:0
    },
    {
        id:22,
        name:"Hot Tub",
        price:6000,
        link:"https://neal.fun/spend/images/hot-tub.jpg",
        count:0
    },
    {
        id:23,
        name:"Luxury Wine",
        price:7000,
        link:"https://neal.fun/spend/images/luxury-wine.jpg",
        count:0
    },
    {
        id:24,
        name:"Diamond Ring",
        price:10000,
        link:"https://neal.fun/spend/images/diamond-ring.jpg",
        count:0
    },
    {
        id:25,
        name:"Jet Ski",
        price:12000,
        link:"https://neal.fun/spend/images/jet-ski.jpg",
        count:0
    },
    {
        id:26,
        name:"Rolex",
        price:15000,
        link:"https://neal.fun/spend/images/rolex.jpg",
        count:0
    },
    {
        id:27,
        name:"Ford F-150",
        price:30000,
        link:"https://neal.fun/spend/images/ford-f-150.jpg",
        count:0
    },
    {
        id:28,
        name:"Tesla",
        price:75000,
        link:"https://neal.fun/spend/images/tesla.jpg",
        count:0
    },
    {
        id:29,
        name:"Monster Truck",
        price:150000,
        link:"https://neal.fun/spend/images/monster-truck.jpg",
        count:0
    },
    {
        id:30,
        name:"Ferrari",
        price:250000,
        link:"https://neal.fun/spend/images/ferrari.jpg",
        count:0
    },
    {
        id:31,
        name:"Single Family Home",
        price:300000,
        link:"https://neal.fun/spend/images/single-family-home.jpg",
        count:0
    },
    {
        id:32,
        name:"Gold Bar",
        price:700000,
        link:"https://neal.fun/spend/images/gold-bar.jpg",
        count:0
    },
    {
        id:33,
        name:"McDonalds Franchise",
        price:1500000,
        link:"https://neal.fun/spend/images/mcdonalds-franchise.jpg",
        count:0
    },
    {
        id:34,
        name:"Superbowl Ad",
        price:5250000,
        link:"https://neal.fun/spend/images/superbowl-ad.jpg",
        count:0
    },
    {
        id:35,
        name:"Yacht",
        price:7500000,
        link:"https://neal.fun/spend/images/yacht.jpg",
        count:0
    },
    {
        id:36,
        name:"M1 Abrams",
        price:8000000,
        link:"https://neal.fun/spend/images/m1-abrams.jpg",
        count:0
    },
    {
        id:37,
        name:"Formula 1 Car",
        price:15000000,
        link:"https://neal.fun/spend/images/formula-1-car.jpg",
        count:0
    },
    {
        id:38,
        name:"Apache Helicopter",
        price:31000000,
        link:"https://neal.fun/spend/images/apache-helicopter.jpg",
        count:0
    },
    {
        id:39,
        name:"Mansion",
        price:45000000,
        link:"https://neal.fun/spend/images/mansion.jpg",
        count:0
    },
    {
        id:40,
        name:"Make a Movie",
        price:100000000,
        link:"https://neal.fun/spend/images/make-a-movie.jpg",
        count:0
    },
    {
        id:41,
        name:"Boeing 747",
        price:148000000,
        link:"https://neal.fun/spend/images/boeing-747.jpg",
        count:0
    },
    {
        id:42,
        name:"Mona Lisa",
        price:780000000,
        link:"https://neal.fun/spend/images/mona-lisa.jpg",
        count:0
    },
    {
        id:43,
        name:"Skyscraper",
        price:850000000,
        link:"https://neal.fun/spend/images/skyscraper.jpg",
        count:0
    },
    {
        id:44,
        name:"Cruise Ship",
        price:930000000,
        link:"https://neal.fun/spend/images/cruise-ship.jpg",
        count:0
    },
    {
        id:45,
        name:"NBA Team",
        price:2120000000,
        link:"https://neal.fun/spend/images/nba-team.jpg",
        count:0
    }
]

export default items;